export function Home() {
    return (
        <span>
            Home
        </span>
    )
}